import { queryKeys } from './queries'

/** Human-readable labels for task names (mirrors backend TASK_META). */
export const TASK_LABELS: Record<string, string> = {
  book_shipping: 'Booking freight',
  send_po_email: 'Sending PO email',
  generate_purchase_orders: 'Generating purchase orders',
  fulfill_shipment: 'Creating Shopify fulfillment',
  analyze_po_reply: 'Analyzing manufacturer reply',
  analyze_outbound_reply: 'Analyzing outbound email',
  analyze_customer_comm: 'Analyzing customer email',
  process_graph_notification: 'Processing incoming email',
  process_customer_graph_notification: 'Processing customer email',
  process_shopify_webhook: 'Processing Shopify webhook',
  sync_all_orders: 'Syncing orders',
  collect_shopping: 'Collecting competitor prices',
  collect_offers: 'Collecting shopping offers',
  collect_prices: 'Updating product prices',
}

/**
 * Maps task name → React Query keys to invalidate when the task completes.
 * This gives near-instant data refresh when background operations finish.
 */
export const TASK_INVALIDATION_MAP: Record<string, readonly (readonly unknown[])[]> = {
  book_shipping: [
    queryKeys.shipments.all,
    queryKeys.purchaseOrders.all,
    queryKeys.projects.all,
  ],
  send_po_email: [queryKeys.purchaseOrders.all, queryKeys.communications.all],
  generate_purchase_orders: [
    queryKeys.purchaseOrders.all,
    queryKeys.orders.all,
    queryKeys.projects.all,
    queryKeys.dashboardSummary.all,
  ],
  fulfill_shipment: [queryKeys.shipments.all, queryKeys.projects.all],
  analyze_po_reply: [
    queryKeys.purchaseOrders.all,
    queryKeys.communications.all,
    queryKeys.projects.all,
    queryKeys.dashboardSummary.all,
  ],
  analyze_outbound_reply: [queryKeys.communications.all, queryKeys.purchaseOrders.all],
  analyze_customer_comm: [queryKeys.customerComms.all],
  process_graph_notification: [
    queryKeys.communications.all,
    queryKeys.purchaseOrders.all,
    queryKeys.projects.all,
  ],
  process_customer_graph_notification: [queryKeys.customerComms.all],
  process_shopify_webhook: [
    queryKeys.orders.all,
    queryKeys.projects.all,
    queryKeys.dashboardSummary.all,
  ],
  sync_all_orders: [
    queryKeys.orders.all,
    queryKeys.projects.all,
    queryKeys.dashboardSummary.all,
  ],
  collect_shopping: [queryKeys.products.all],
  collect_offers: [queryKeys.products.all],
  collect_prices: [queryKeys.products.all],
}

/**
 * Tasks whose start and failure also refresh these caches, so a conversation shows the AI
 * analysis as soon as it begins (or stops) rather than only when it finishes.
 */
export const TASK_PROGRESS_INVALIDATION_MAP: Record<string, readonly (readonly unknown[])[]> = {
  analyze_po_reply: [queryKeys.communications.all],
  analyze_spec_credit_reply: [queryKeys.communications.all],
  analyze_outbound_reply: [queryKeys.communications.all],
}
